import InputC from 'Common/Inputs/index.tsx';
import Folderimg from '../../assets/V2-images/folder.svg';
import { SearchTagkeyword, Searchfolderkeyword } from 'components/Dam/DAM_API/urls';
import Axios from 'functions/Axios';
import React, { useEffect, useRef, useState } from 'react';
import single from '../../assets/V2-images/single.png';
import group from '../../assets/V2-images/group.png';
import person from '../../assets/V2-images/person.png';
import { DAM_SVG } from 'components/Dam/DamAssets';
export const ArrowDropDownSvgIconComponent = ({ ISACTIVE = true }) => {
  return (
    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.37788 4.025L1.15288 1.775C0.869551 1.49167 0.802885 1.16667 0.952885 0.8C1.10288 0.433334 1.38622 0.25 1.80289 0.25H6.22789C6.62789 0.25 6.90689 0.433334 7.06489 0.8C7.22355 1.16667 7.16122 1.49167 6.87788 1.775L4.65288 4.025C4.55288 4.10833 4.45289 4.175 4.35289 4.225C4.25289 4.275 4.13622 4.3 4.00288 4.3C3.88622 4.3 3.77788 4.275 3.67789 4.225C3.57789 4.175 3.47788 4.10833 3.37788 4.025Z"
        fill={ISACTIVE ? '#F6F6F6' : '#1E293B'}
      />
    </svg>
  );
};

const colors = [
  'red',
  'green',
  'blue',
  'yellow',
  'teal',
  'purple',
  'black',
  'lightblue',
  'olive',
  'brown',
  'pink',
  'orange',
  'lime',
  'cyan',
  'grey',
];

export const Viewbuttonfolderv2 = ({
  size,
  text,
  value,
  onSelectFilter,
  selectedValue,
  inputSearch,
  setInputSearch,
  datafilter,
  selectedFormats,
  datashow,
  today,
  setDesignationdata,
  setcreatedon,
  Designationdata,
  setfiltereddata,
  filtereddata,
  state,
  setstate,
  isSubFilter = false,
  isExtension,
  setIsExtension,
  customValue = false,
  setCustomValue,
  searchValue,
  setSearchValue,
  optionLabel = 'type',
  optionValue = 'id',
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFolders, setSelectedFolders] = useState([]);
  const [selectedFoldersData, setSelectedFoldersData] = useState([]);
  const [searchfolder, setsearchfolder] = useState([]);
  const [dateFilterValue, setDateFilterValue] = useState({});
  const [subfiltersData, setSubfiltersData] = useState([]);
  const [subfilterschecker, setSubfiltersChecker] = useState([]);
  const [isCustom, setIsCustom] = useState(customValue);
  const filterdesignationData = selectedFormats;
  const threedotIconRef = useRef();
  const [Editanddelete, SetEditanddelete] = useState();
  const [EditanddeleteValidation, SetEditanddeleteValidation] = useState();
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleFilterSelection = (filterValue) => {
    if (onSelectFilter) {
      onSelectFilter(filterValue);
    }
    const index = filtereddata?.findIndex((item) => item === filterValue);

    if (index === -1) {
      // If filterValue doesn't exist, add it to filteredData
      if (text === 'Creation Date') {
        setfiltereddata([filterValue]);
      } else {
        setfiltereddata([...filtereddata, filterValue]);
      }
    } else {
      // If filterValue exists, remove it from filteredData
      const updatedData = filtereddata?.filter((item, idx) => idx !== index);
      setfiltereddata(updatedData);
    }
  };

  const handleFilterSelect = (dateRange) => {
    let startDate = new Date();
    let endDate = new Date();
    const today = new Date();
    switch (dateRange) {
      case 'Today':
        // startDate = new Date(startDate.setHours(0, 0, 0, 0));
        startDate = 0;
        break;
      case 'Last 7 days':
        // startDate.setDate(today.getDate() - 7);
        startDate = 7;
        break;
      case 'Last 30 days':
        // startDate.setDate(today.getDate() - 30);
        startDate = 30;
        break;
      case 'Last 90 days':
        // startDate.setDate(today.getDate() - 90);
        startDate = 90;
        break;
      case 'Last 180 days':
        // startDate.setDate(today.getDate() - 180);
        startDate = 180;
        break;
      default:
        break;
    }

    const index = filtereddata?.findIndex((item) => item === dateRange);
    if (index === -1 || index === undefined) {
      // If filterValue doesn't exist, add it to filteredData
      if (filtereddata === null) {
        filtereddata = [];
      }
      setcreatedon([...state, dateRange]);
      setfiltereddata([...filtereddata, dateRange]);
      if (onSelectFilter) {
        onSelectFilter({ startDate, endDate });
      }
    } else {
      // If filterValue exists, remove it from filteredData
      const updatedData = filtereddata?.filter((item, idx) => idx !== index);
      setfiltereddata(updatedData);
      const index1 = state?.findIndex((item) => item === dateRange);

      const updatedData1 = state?.filter((item, idx) => idx !== index1);
      setcreatedon(updatedData1);
      setfiltereddata(updatedData1);
      var blacnk = '';
      if (onSelectFilter) {
        onSelectFilter(blacnk);
      }
    }
  };

  const Handleeditanddelete = (id) => {
    if (EditanddeleteValidation == id) {
      SetEditanddeleteValidation();
    } else {
      SetEditanddelete(id);
      SetEditanddeleteValidation(id);
    }
  };

  const handleSearch = async (event) => {
    setSearchTerm(event.target.value);
    if (text === 'Folder') {
      try {
        let url = Searchfolderkeyword + event.target.value;
        // if (insideFolderId) {
        //   url += `&folderId=${insideFolderId}`;
        // }
        const { data } = await Axios.get(url);

        const mergedUnique = [...data?.data, ...searchfolder.slice(0, 5)].filter(
          (item, index, self) => index === self.findIndex((i) => i.id === item.id),
        );

        setsearchfolder(mergedUnique);
      } catch (error) {
        console.error('Error occurred while searching folders:', error);
      }
    }

    if (value === 'tags') {
      try {
        const data = await Axios.get(SearchTagkeyword + event.target.value);
        //tagId
        const mergedUnique = [...data?.data?.data, ...searchfolder.slice(0, 5)].filter(
          (item, index, self) => index === self.findIndex((i) => i.tagId === item.tagId),
        );
        setsearchfolder(mergedUnique);
      } catch (error) {
        console.error('Error occurred while searching folders:', error);
      }
    }
  };

  const handleFolderCheckboxChange = (folderId, folders) => {
    if (filtereddata.includes(folderId)) {
      // If folder is already selected, remove it
      const updatedData = filtereddata.filter((id) => id !== folderId);
      setfiltereddata(updatedData);
      setstate(state.filter((id) => id !== folderId)); // Remove folderId from state array
    } else {
      const retained_data = localStorage.getItem(text);
      const parsedRetainedData = retained_data ? JSON.parse(retained_data) : [];

      const allData = [...parsedRetainedData, folders];
      const uniqueData = Array.from(new Set(allData.map((item) => JSON.stringify(item)))).map(
        (item) => JSON.parse(item),
      );

      const formattedData = uniqueData.slice(-5);

      localStorage.setItem(text, JSON.stringify(formattedData));

      setfiltereddata([...filtereddata, folderId]);
      setstate([...state, folderId]); // Add folderId to state array
    }
  };

  const handleFolderSelection = (value) => {
    if (!selectedFolders.includes(value.folderId)) {
      setSelectedFolders([...selectedFolders, value.folderId ?? value?.tagName]);
      setSelectedFoldersData([...selectedFoldersData, value]);
    } else {
      const updatedFolders = selectedFolders.filter(
        (id) => id !== value.folderId ?? value?.tagName,
      );
      setSelectedFolders(updatedFolders);
      setSelectedFoldersData((prev) =>
        prev.filter((item) => item?.folderId !== value.folderId ?? value?.tagName),
      );
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (threedotIconRef.current && !threedotIconRef.current.contains(event.target)) {
        yourFunction();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setIsCustom(customValue);
  }, [customValue]);

  const yourFunction = () => {
    // openfunction(text);
    SetEditanddelete();
  };

  return (
    <div className="d-flex">
      <div
        className={`d-flex gap-2 justify-content-center p_relative designatio_filter_height_width entities_dropdown_desing ${Editanddelete === text && 'bg_black text_color_filter'} ${state?.length > 0 && 'bg_black text_color_filter'} cursor_pointer`}
      >
        <div
          className="d-flex align-items-center gap-2 pointer"
          onClick={() => Handleeditanddelete(text)}
          // ref={dropdownRef}
        >
          <div className="foldertxt">{text}</div>
          {state?.length > 0 && (
            <div className="countcircle">{text === 'Faces' ? 1 : state?.length}</div>
          )}
          <div>
            <ArrowDropDownSvgIconComponent ISACTIVE={Editanddelete === text} />
          </div>
        </div>

        <div
          // className={`relative`}
          style={{
            paddingTop: '4px',
          }}
        >
          {Editanddelete === text && (
            <>
              <div
                className={`threedotsiconclickfunction2nd  filter_upper_navigator `}
                ref={threedotIconRef}
                style={{
                  gap: '0px',
                }}
              >
                {/* <div className="sub_head_design font_w_600 border_botton_desgin_hr p-4">{text}</div> */}
                {isSubFilter === true && (
                  <div className="dis_grid gap-2 p-2">
                    <div className="dis_grid  gap-2">
                      <div
                        style={{
                          color: 'black',
                        }}
                      >
                        <div className="d-flex align-items-center gap-2 filter_padding_desing">
                          <div>
                            <input
                              type="checkbox"
                              className="w_h_18p"
                              checked={isExtension}
                              onChange={(e) => {
                                setIsExtension(e.target.checked);
                              }}
                            />
                          </div>
                          <div className="task_history_header_desing_2 sub_head_design">
                            Search By Extension
                          </div>
                        </div>
                      </div>
                    </div>
                    {isExtension && (
                      <div
                        style={{
                          width: '60%',
                        }}
                      >
                        {' '}
                        <InputC
                          type="Searchbar"
                          placeholder="Search agenda, staff meeting, customer name"
                          size="lg"
                          // name=""
                          inputvalue={inputSearch}
                          change={(e) => {
                            setInputSearch(e.target.value);
                          }}
                          // change={(e) => {
                          //   setSearch(e.target.value);
                          // }}
                          // inputvalue={search}
                        />
                      </div>
                    )}
                    <div
                      className={`d-flex gap-2 ${isExtension && 'hide_pointers'}  display_block_assigner `}
                    >
                      <div
                        className="dis_grid  gap-2"
                        style={{
                          // width: '30%',
                          borderRight: '1px solid #E6E6E6',
                          paddingRight: '1rem',
                          height: 'fit-content',
                        }}
                      >
                        {filterdesignationData?.map((item, index) => (
                          <div
                            className="d-flex align-items-center gap-2 filter_padding_desing  justify-content-between"
                            key={index}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <div>
                                <input
                                  type="checkbox"
                                  className="w_h_18p"
                                  checked={filtereddata?.some(
                                    (_item) => typeof _item === 'object' && _item?.id === item?.id,
                                  )}
                                  onChange={(e) => {
                                    if (text === 'CreationDate') {
                                      handleFilterSelect(item);
                                    } else {
                                      handleFilterSelection(item);
                                    }
                                  }}
                                />
                              </div>
                              <div className="task_history_header_desing_2 sub_head_design">
                                {item?.type}
                              </div>
                            </div>
                            <div
                              className={`arrow_Icon_svg ${subfilterschecker.includes(item?.id) && 'selected_svg'}`}
                              style={{
                                marginLeft: '5rem',
                              }}
                              onClick={() => {
                                if (subfilterschecker.includes(item?.id)) {
                                  // If item is already selected, unselect it
                                  setSubfiltersChecker((prev) =>
                                    prev.filter((_item) => _item !== item?.id),
                                  );
                                  setSubfiltersData((prevData) =>
                                    prevData.filter((ext) => !item?.extensions.includes(ext)),
                                  );
                                } else {
                                  // If item is not selected, select it
                                  // setSubfiltersChecker((prev) => [...prev, item?.id]);
                                  setSubfiltersChecker((prev) => [item?.id]);

                                  // setSubfiltersData((prev) => [...prev, ...item?.extensions]);
                                  setSubfiltersData((prev) => [...item?.extensions]);
                                }
                              }}
                            >
                              {DAM_SVG.rightArrowSvgIcon}
                            </div>
                          </div>
                        ))}
                      </div>

                      <div
                        style={{
                          // width: '70%',
                          maxHeight: '200px',
                          overflow: 'auto',
                          // background: '#753cb7',
                          // borderRadius: '12px',

                          padding: '0.5rem',
                          paddingRight: '10rem',
                          height: 'fit-content',
                        }}
                        className="dis_grid gap-2"
                      >
                        {subfiltersData?.map((item, index) => (
                          <div
                            className="d-flex align-items-center gap-2 filter_padding_desing"
                            key={index}
                          >
                            <div>
                              <input
                                type="checkbox"
                                className="w_h_18p"
                                checked={filtereddata?.includes(item)}
                                onChange={(e) => {
                                  if (text === 'CreationDate') {
                                    handleFilterSelect(item);
                                  } else {
                                    handleFilterSelection(item);
                                  }
                                }}
                              />
                            </div>
                            <div className="task_history_header_desing_2 sub_head_design">
                              {item}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                {isSubFilter === false && (
                  <div>
                    {filterdesignationData?.map((item) => (
                      <div
                        className="d-flex align-items-center gap-2 filter_padding_desing"
                        key={item?.id} // Use item id if available
                      >
                        <div>
                          <input
                            type="checkbox"
                            className="w_h_18p"
                            checked={filtereddata?.includes(
                              value === 'creationDate' ? item?.id : item?.label,
                            )}
                            onChange={() => {
                              const filterValue = value === 'creationDate' ? item?.id : item?.label;
                              setIsCustom(false);
                              if (item?.isCustom) {
                                handleFilterSelect(item?.id);
                              } else {
                                handleFilterSelection(filterValue);
                              }
                            }}
                          />
                        </div>
                        <div className="task_history_header_desing_2 sub_head_design">
                          {item?.label}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {value === 'creationDate' && (
                  <div className="">
                    <div className="d-flex align-items-center gap-2 filter_padding_desing">
                      <div>
                        <input
                          type="checkbox"
                          className="w_h_18p"
                          checked={isCustom}
                          onChange={(e) => {
                            setfiltereddata([]);
                            setCustomValue && setCustomValue(e.target.checked);
                            setIsCustom(e.target.checked);
                          }}
                        />
                      </div>
                      <div className="task_history_header_desing_2 sub_head_design">Custom</div>
                    </div>
                    {isCustom && (
                      <div className="d-flex gap-2">
                        <div>
                          <label className="text-black">Start Date</label>
                          <input
                            type="date"
                            className="dateinput p-2"
                            value={dateFilterValue?.startDate}
                            onChange={(e) => {
                              setDateFilterValue((prev) => ({
                                ...prev,
                                startDate: e.target.value,
                              }));
                              onSelectFilter({
                                startDate: e.target.value,
                                endDate: dateFilterValue?.endDate,
                                isCustom: true,
                              });
                            }}
                            max={new Date().toISOString().split('T')[0]}
                          />
                        </div>
                        <div>
                          <label className="text-black">End Date</label>

                          <input
                            type="date"
                            className="dateinput p-2"
                            value={dateFilterValue?.endDate}
                            onChange={(e) => {
                              setDateFilterValue((prev) => ({
                                ...prev,
                                endDate: e.target.value,
                              }));
                              onSelectFilter({
                                startDate: dateFilterValue?.startDate,
                                endDate: e.target.value,
                                isCustom: true,
                              });
                            }}
                            max={new Date().toISOString().split('T')[0]}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {value === 'color' && (
                  <div className="dis_grid grid_cols_3 gap-4 p-2">
                    {colors?.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          color: 'black',
                          alignItems: 'center',
                          width: '150px',
                        }}
                        className="d-flex  items-center gap-2"
                        onClick={() => {
                          if (selectedValue?.includes(item)) {
                            onSelectFilter(selectedValue?.filter((_item) => _item !== item));
                          } else {
                            onSelectFilter([...selectedValue, item]);
                          }
                        }}
                      >
                        <div
                          className={`backbody ${selectedValue?.includes(item) && 'backbody_selected'}`}
                        >
                          <div
                            className={`circle `}
                            style={{
                              backgroundColor: item,
                            }}
                          ></div>
                        </div>
                        <div>{item}</div>
                      </div>
                    ))}
                  </div>
                )}

                {value === 'face' && (
                  <div className="dis_grid grid_cols_3 gap-4 p-2">
                    <div
                      className={`backbody ${selectedValue === '1' && 'backbody_selected'}`}
                      onClick={() => {
                        onSelectFilter(selectedValue === '1' ? '' : '1');
                      }}
                    >
                      <img src={single} alt=".." />
                    </div>
                    <div
                      className={`backbody ${selectedValue === '2' && 'backbody_selected'}`}
                      onClick={() => {
                        onSelectFilter(selectedValue === '2' ? '' : '2');
                      }}
                    >
                      <img src={group} alt=".." />
                    </div>
                    <div
                      className={`backbody ${selectedValue === '3' && 'backbody_selected'}`}
                      onClick={() => {
                        onSelectFilter(selectedValue === '3' ? '' : '3');
                      }}
                    >
                      <img src={person} alt=".." />
                    </div>
                  </div>
                )}

                {text === 'Folder' ? (
                  <div
                    className="d-flex search-box justify-content-between p-2"
                    style={{
                      marginRight: '0px',
                    }}
                  >
                    <div className="d-flex w-100">
                      <img src="/manage/images/SVG/search.svg" alt="" />
                      <input
                        type="text"
                        value={searchTerm}
                        // className="Custom-input"
                        onChange={handleSearch}
                        autoComplete="off"
                        style={{
                          borderBottom: 'none',
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {value === 'tags' && (
                  <div
                    className="d-flex search-box justify-content-between p-2"
                    style={{
                      marginRight: '0px',
                    }}
                  >
                    <div className="d-flex w-100">
                      <img src="/manage/images/SVG/search.svg" alt="" />
                      <input
                        type="text"
                        value={searchTerm}
                        onChange={handleSearch}
                        autoComplete="off"
                        style={{
                          borderBottom: 'none',
                        }}
                      />
                    </div>
                  </div>
                )}

                {searchTerm !== '' ? (
                  <div
                    className=" mt-3"
                    style={{
                      maxHeight: '300px',
                      overflow: 'auto',
                    }}
                  >
                    {searchfolder.map((value, index) => (
                      <div
                        className="d-flex align-items-center gap-3 folderhover pointer mb-2"
                        key={index}
                        // onClick={() => handleFolderSelection(value)}
                      >
                        <input
                          type="checkbox"
                          className="w_h_18p"
                          checked={filtereddata.includes(
                            value.folderId ? value.folderId : value?.id ? value?.id : value.tagName,
                          )}
                          onChange={(e) =>
                            handleFolderCheckboxChange(
                              value.folderId
                                ? value.folderId
                                : value?.id
                                  ? value?.id
                                  : value.tagName,
                              value,
                            )
                          }
                        />
                        {/* {value !== 'tags' && <img src={Folderimg} alt="Folder Icon" />} */}
                        <span className="sub_head_design">
                          {value?.folderName ?? value?.tagName}{' '}
                        </span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className={selectedFoldersData?.length > 0 && 'mt-3'}
                    style={{
                      maxHeight: '300px',
                      overflow: 'auto',
                    }}
                  >
                    {selectedFoldersData?.map((value, index) => (
                      <div
                        className="d-flex align-items-center gap-3 folderhover pointer mb-2"
                        key={index}
                        onClick={() => handleFolderSelection(value)}
                      >
                        <input
                          type="checkbox"
                          className="w_h_18p"
                          checked={filtereddata.includes(
                            value.folderId ? value.folderId : value?.id ? value?.id : value.tagName,
                          )}
                          onChange={(e) =>
                            handleFolderCheckboxChange(
                              value.folderId
                                ? value.folderId
                                : value?.id
                                  ? value?.id
                                  : value.tagName,
                              value,
                            )
                          }
                        />
                        {/* <img src={Folderimg} alt="Folder Icon" /> */}
                        {value !== 'tags' && <img src={Folderimg} alt="Folder Icon" />}
                        <span className="sub_head_design">
                          {value?.folderName ?? value?.tagName} sd
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
